import React from "react"
import styles from "./styles.scss"
import SideNav from "components/SideNav"
import {
  selectAdsAsArray,
  getAds,
  destroyAd,
  getAdsBySearch,
} from "data/ads"
import { connect } from "react-redux"
import { adEditPath } from "utils/paths"
import Table from "components/Table"
import { Link } from "react-router-dom"
import AdminHeader from "../../components/AdminHeader"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Ad from "components/Ad"
import cx from "classnames"
import Waypoint from "react-waypoint"

class AdIndex extends React.Component {
  state = {
    currentPage: 1,
    adExpanded: "",
    searchValue: "",
  }
  componentDidMount() {
    const { currentPage } = this.state
    this.props.getAds(currentPage)
  }

  _handleWaypointEnter = () => {
    const { currentPage, searchValue } = this.state
    if (!searchValue) {
      this.props.getAds(currentPage)
      this.setState({ currentPage: this.state.currentPage + 1 })
    }
  }

  handleRowClick(id) {
    this.setState(prevState => ({
      adExpanded: prevState.adExpanded === id ? "null" : id,
    }))
  }
  onDelete = id => {
    window.confirm("Är du säker att du vill ta bort annonsen?") &&
      this.props.destroyAd(id)
  }

  handleSearchChange = event => {
    this.setState({ searchValue: event.target.value })
    this.props.getAdsBySearch(event.target.value)
  }

  render() {
    const { ads } = this.props
    return (
      <div className={styles.container}>
        <div className={styles.mainContent}>
          <AdminHeader />
          <div className={styles.adtableWrapper}>
            <SideNav type="ads" />
            <div className={styles.adTable}>
              <Table
                title="Annonser"
                onSearchChange={this.handleSearchChange}
              >
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Body</th>
                    <th>Läs mer-länk</th>
                    <th> Aktiv </th>
                    <th />
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {ads.map(ad => {
                    return [
                      <tr className={styles.everyTwo} key={ad.id}>
                        <td onClick={() => this.handleRowClick(ad.id)}>
                          {ad.title}
                        </td>
                        <td>{ad.body}</td>
                        <td>{ad.adUrl}</td>
                        <td
                          className={
                            ad.isActive
                              ? styles.activeText
                              : styles.inactiveText
                          }
                        >
                          {ad.isActive ? "Aktiv" : "Inaktiv"}
                        </td>
                        <td>
                          <Link to={adEditPath(ad.id)}>
                            <FontAwesomeIcon icon="pencil-alt" />{" "}
                          </Link>
                        </td>
                        <td
                          className={styles.deleteField}
                          onClick={() => this.onDelete(ad.id)}
                        >
                          <FontAwesomeIcon icon="trash-alt" />
                        </td>
                      </tr>,

                      <tr key={ad.id * 23}>
                        <td>
                          <div
                            className={cx(styles.hiddenAd, {
                              [styles.expandedAd]:
                                this.state.adExpanded === ad.id,
                            })}
                          >
                            <Ad
                              image={ad.imgurl}
                              title={ad.title}
                              body={ad.body}
                            />
                          </div>
                        </td>
                      </tr>,
                    ]
                  })}
                </tbody>
              </Table>
              <Waypoint onEnter={this._handleWaypointEnter} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  ads: selectAdsAsArray(state, ownProps),
})

export default connect(
  mapStateToProps,
  {
    getAds,
    getAdsBySearch,
    destroyAd,
  }
)(AdIndex)



// WEBPACK FOOTER //
// src/pages/Admin/Ads/AdIndex/index.jsx